<template>
    <b-container fluid class="container-custom-padding">
        <!-- Title and button -->
        <ReportsTitle/>

        <!-- Action bar row -->
        <ReportsActionBar @do-query="submitData"/>

        <!-- Filter -->
        <!-- <b-row>
            <ReportsFilter/>
        </b-row> -->
        <!-- Table -->
        <b-row>
            <b-col cols="12">
                <AuditsTable @do-query="submitData" />
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    // components
    import ReportsActionBar from "./ReportsActionBar";
    import ReportsTitle from "./ReportsTitle";
    import AuditsTable from "./AuditsTable";
    import {mapActions, mapGetters} from "vuex";
    import {
        GET_REPORTS_START_DATE,
        GET_REPORTS_END_DATE
    } from "../../store/actions/date-time";
    import {
        FETCH_LOG_ENTRIES,
        GET_SELECTED_DAMS,
        RESET_LOG_DATA
    } from "../../store/actions/reports";

    export default {
        name: 'AuditsContainer',
        components: {
            ReportsTitle,
            ReportsActionBar,
            AuditsTable
        },
        computed: {
            ...mapGetters([GET_REPORTS_START_DATE, GET_REPORTS_END_DATE, GET_SELECTED_DAMS])
        },
        methods: {
            ...mapActions([FETCH_LOG_ENTRIES, RESET_LOG_DATA]),
            submitData(page) {
                const reqObject = {
                    start: this.GET_REPORTS_START_DATE,
                    end: this.GET_REPORTS_END_DATE,
                    objects: this.GET_SELECTED_DAMS,
                    page: page
                };
                this.FETCH_LOG_ENTRIES(reqObject);
            }
        },
        beforeDestroy() {
            this.RESET_LOG_DATA();
        }
    }
</script>

<style>
</style>